import { store } from '../redux/store'
import { clearUser } from '../redux/slice/user'

/**
 * Функция для разлогинивания пользователя
 * Очищает токены, Redux store и перенаправляет на страницу логина
 */
export const logoutUser = () => {
  console.log('Logging out user');
  
  // Очищаем токены
  localStorage.removeItem('accessToken');
  sessionStorage.removeItem('accessToken');
  localStorage.removeItem('user');
  
  // Очищаем Redux store
  store.dispatch(clearUser());
  
  // Перенаправляем на страницу логина
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

/**
 * Проверяет, является ли ошибка связанной с токеном
 */
export const isTokenError = (error: any): boolean => {
  if (!error.response || !error.response.data) {
    return false;
  }
  
  const { success, message, error: errorMsg } = error.response.data;
  
  return (
    (success === false && (message === 'Invalid token' || errorMsg === 'Invalid token')) ||
    (success === false && (message === 'jwt malformed' || errorMsg === 'jwt malformed')) ||
    error.response.status === 401 ||
    (message && message.toLowerCase().includes('token')) ||
    (errorMsg && errorMsg.toLowerCase().includes('token'))
  );
};

/**
 * Получает токен из localStorage или sessionStorage
 */
export const getAuthToken = (): string | null => {
  return sessionStorage.getItem('accessToken') || localStorage.getItem('accessToken');
};

/**
 * Проверяет, авторизован ли пользователь
 */
export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
}; 